export const completeFillRequestDefault = '{\n' +
    '    "fillId": "",\n' +
    '    "personId": "",\n' +
    '    "prescriptionId": "",\n' +
    '    "profileId": "",\n' +
    '    "dateShipComplete": ""\n' +
    '}';

export interface ICompleteFillRequest {
    fillId: string
    personId: string
    prescriptionId: string
    profileId: string
    dateShipComplete?: string
}